class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
// Sidebar cart hide
  customElements.define('cart-drawer', CartDrawer); 

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
 

// function updateCartCountBubbleFromCart(cart) {
//   const bubbleWrapper = document.querySelector('.cart-count-bubble');
//   if (!bubbleWrapper) return;

//   const bubble = bubbleWrapper.querySelector('span');
//   if (!bubble) return;

//   bubble.textContent = cart.item_count;

//   if (cart.item_count > 0) {
//     bubbleWrapper.classList.remove('hidden');
//   } else {
//     bubbleWrapper.classList.add('hidden');
//   }
// }

// document.addEventListener('rebuy:cart:updated', (event) => {
//   if (!event.detail?.cart) return;
//   updateCartCountBubbleFromCart(event.detail.cart);
// });

//subscribe and save 
//  document.addEventListener("click", async function (e) {
//   const btn = e.target.closest(".cart-subscribe-btn");
//   if (!btn) return;

//   e.preventDefault();

//   if (btn.classList.contains("loading")) return;
//   btn.classList.add("loading");

//   const line = Number(btn.dataset.line);
//   const variantId = Number(btn.dataset.variantId);
//   const sellingPlan = Number(btn.dataset.sellingPlan);

//   try {

//     // Remove one-time product
//     await fetch("/cart/change.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         line,
//         quantity: 0
//       })
//     });

//     // Add subscription product
//     const formData = new FormData();
//     formData.append("id", variantId);
//     formData.append("quantity", 3);
//     formData.append("selling_plan", sellingPlan);

//     await fetch("/cart/add.js", {
//       method: "POST",
//       body: formData
//     });

//     // Get updated cart sections
//     const sections = [
//       "cart-drawer",
//       "cart-icon-bubble"
//     ];

//     const res = await fetch(
//       `${window.location.pathname}?sections=${sections.join(",")}`
//     );

//     const parsedState = await res.json();

//     const cartDrawer = document.querySelector("cart-drawer");

//     cartDrawer.renderContents({
//       id: variantId,
//       sections: {
//         "cart-drawer": parsedState["cart-drawer"],
//         "cart-icon-bubble": parsedState["cart-icon-bubble"]
//       }
//     });

//   } catch (err) {
//     console.error(err);
//   } finally {
//     btn.classList.remove("loading");
//   }
// });

document.addEventListener('click', async function (event) {
  const button = event.target.closest('.cart-subscribe-btn');

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  if (button.disabled) return;

  const line = parseInt(button.dataset.line, 10);
  const variantId = parseInt(button.dataset.variantId, 10);
  const sellingPlanId = parseInt(button.dataset.sellingPlan, 10);

  if (!line || !variantId || !sellingPlanId) {
    console.error('Subscribe data missing:', {
      line,
      variantId,
      sellingPlanId
    });
    return;
  }

  button.disabled = true;
  button.classList.add('loading');

  try {
    /*
     * Get current cart first.
     * This is important because another subscription line
     * for the same variant may already exist.
     */
    const cartResponse = await fetch('/cart.js');

    if (!cartResponse.ok) {
      throw new Error('Unable to get cart data.');
    }

    const cart = await cartResponse.json();

    const currentItem = cart.items[line - 1];

    if (!currentItem) {
      throw new Error('Cart item not found.');
    }

    /*
     * Find an existing subscription line for the same variant
     * and same selling plan.
     */
    const existingSubscriptionIndex = cart.items.findIndex((item, index) => {
      return (
        index !== line - 1 &&
        item.variant_id === variantId &&
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan_id === sellingPlanId
      );
    });

    /*
     * If subscription already exists:
     * remove the one-time line and add its quantity
     * to the existing subscription quantity.
     */
    if (existingSubscriptionIndex !== -1) {
      const existingSubscriptionItem =
        cart.items[existingSubscriptionIndex];

      const newQuantity =
        existingSubscriptionItem.quantity + 3;

      /*
       * First remove the one-time line.
       */
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (!removeResponse.ok) {
        throw new Error('Unable to remove one-time product.');
      }

      /*
       * After removing a previous line, cart line indexes can change.
       * Find the subscription line again using variant + selling plan.
       */
      const refreshedCartResponse = await fetch('/cart.js');
      const refreshedCart = await refreshedCartResponse.json();

      const subscriptionLineIndex = refreshedCart.items.findIndex((item) => {
        return (
          item.variant_id === variantId &&
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan_id === sellingPlanId
        );
      });

      if (subscriptionLineIndex === -1) {
        throw new Error('Subscription line not found.');
      }

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: subscriptionLineIndex + 1,
          quantity: newQuantity
        })
      });

    } else {

      /*
       * No existing subscription line.
       * Remove one-time item.
       */
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      });

      if (!removeResponse.ok) {
        throw new Error('Unable to remove one-time product.');
      }

      /*
       * Add subscription item with quantity 3.
       */
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', 3);
      formData.append('selling_plan', sellingPlanId);

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!addResponse.ok) {
        throw new Error('Unable to add subscription product.');
      }
    }

    /*
     * Refresh Dawn cart drawer.
     */
    const sectionsResponse = await fetch(
      `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
    );

    if (!sectionsResponse.ok) {
      throw new Error('Unable to refresh cart drawer.');
    }

    const sections = await sectionsResponse.json();

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.renderContents({
        id: variantId,
        sections: {
          'cart-drawer': sections['cart-drawer'],
          'cart-icon-bubble': sections['cart-icon-bubble']
        }
      });
    }

  } catch (error) {
    console.error('Subscribe conversion error:', error);
  } finally {
    button.disabled = false;
    button.classList.remove('loading');
  }
});